import { CaseContextType } from '@broker-crm-contexts'

import { CaseStatus, Client, ClientRelationship, ClientVersion, isNaturalClient, Maybe } from '@acre/graphql'

export const getCompanyDirectors = (caseDetails: CaseContextType['details']) => {
  return getDirectors(caseDetails.clients)
}

export const getDirectors = (clients: ClientVersion[]) => {
  const nonNaturalClients = clients.filter((client) => !isNaturalClient(client.details))

  return nonNaturalClients.reduce((clientIds: string[], company) => {
    const relationships = company.details.relationships

    if (!relationships) return clientIds

    const directors = relationships
      .filter((relationship) =>
        [ClientRelationship.DirectorTrustee, ClientRelationship.DirectorTrusteeAndPsc, ClientRelationship.Psc].includes(
          relationship.relationship_type as ClientRelationship,
        ),
      )
      .map((director) => director.relationship_reference!)

    return [...clientIds, ...directors]
  }, [])
}

export const getDonorsOnCase = (clients: Maybe<ClientVersion[]>, caseId: Maybe<string>) => {
  if (!caseId) return []

  const seenDonors = new Set()
  const donors: (ClientVersion & { details: Pick<Client, 'id' | 'first_name' | 'last_name'> })[] = []

  clients?.forEach((client) => {
    client?.details?.deposits?.forEach((deposit) => {
      if (deposit.deposit_for?.includes(caseId) && deposit?.donors?.[0]) {
        const donor = deposit.donors[0]

        if (!seenDonors.has(donor.id)) {
          donors.push(donor)
        }
        seenDonors.add(donor.id)
      }
    })
  })

  return donors
}

// Enum representing all valid case fact find section names as defined in the routes
export enum CaseFactFindSection {
  PersonalInfo = 'personal-info',
  Credit = 'credit',
  Income = 'income',
  Employment = 'employment',
  RetirementIncome = 'retirement-income',
  IdVerification = 'id-verification',
  Properties = 'properties',
  Mortgage = 'mortgage',
  Conveyancing = 'conveyancing',
  Outgoings = 'outgoings',
  Protection = 'protection',
}

export const progresedCaseStatus = [
  CaseStatus.PostRecommendationReview,
  CaseStatus.PostApplication,
  CaseStatus.NotProceeding,
  CaseStatus.ImportedComplete,
  CaseStatus.Importing,
  CaseStatus.ApplicationSubmitted,
  CaseStatus.AwaitingValuation,
  CaseStatus.AwaitingOffer,
  CaseStatus.OfferReceived,
  CaseStatus.Exchange,
  CaseStatus.Complete,
]

export const hiddenSections = [
  'outgoings',
  'mortgage',
  'mortgageNew',
  'properties',
  'conveyancing',
  'protection',
  'impersonation',
  'employment',
]
